/** Developer diagnostics are deliberately silent in production. Never pass user data. */
export function devWarn(message: string, status?: number): void {
  if (process.env.NODE_ENV === 'development') {
    if (status === undefined) {
      console.warn(message);
    } else {
      console.warn(message, status);
    }
  }
}

export function devError(message: string, status?: number): void {
  if (process.env.NODE_ENV === 'development') {
    if (status === undefined) {
      console.error(message);
    } else {
      console.error(message, status);
    }
  }
}
